import type { TFunction } from "i18next";

import type { FormValidationIssue } from "@/components/ui/form-validation";
import type { RoleGroup } from "@/components/people/personFormModel";
import { EMAIL_VALIDATION_ERROR } from "@/lib/emailValidation";

export function collectPersonValidationIssues(
  errors: Record<string, { message?: unknown } | undefined>,
  group: RoleGroup,
  t: TFunction,
): FormValidationIssue[] {
  const targets: Array<[string, string]> = [
    ["last_name", "user-field-last_name"],
    ["first_name", "user-field-first_name"],
    ["patronymic", "user-field-patronymic"],
    ...(group === "office"
      ? ([
          ["web_email", "user-field-email"],
          ["tab_number", "user-field-office-tab"],
          ["unit_id", "user-field-unit-trigger"],
          ["hire_date", "user-field-hire-date"],
          ["termination_date", "user-field-termination-date"],
          ["is_project_manager", "user-field-project-manager"],
        ] satisfies Array<[string, string]>)
      : ([
          ["tab_number", "user-field-tab"],
          ["pin", "user-field-pin"],
          ["unit_id", "user-field-unit-trigger"],
          ["hire_date", "user-field-hire-date"],
          ["termination_date", "user-field-termination-date"],
        ] satisfies Array<[string, string]>)),
  ];
  return targets.flatMap(([name, controlId]) => {
    const raw = String(errors[name]?.message ?? "");
    if (!raw) return [];
    const message =
      raw === "unitRequired"
        ? t("admin.users.errors.unitRequired")
        : raw === "tabFormat"
          ? t("admin.users.errors.tabFormat")
          : raw === "pinFormat"
            ? t("admin.users.errors.pinFormat")
            : raw === "employmentDateOrder"
              ? t("admin.users.errors.employmentDateOrder")
              : raw === "projectManagerRole"
                ? t("admin.users.errors.projectManagerRole")
                : raw === EMAIL_VALIDATION_ERROR.reservedDomain
                  ? t("validation.emailReservedDomain")
                  : raw === EMAIL_VALIDATION_ERROR.invalid || raw.toLowerCase().includes("email")
                    ? t("validation.emailInvalid")
                    : t("admin.users.errors.required");
    return [{ id: `${controlId}-error`, message, kind: "field", controlId }];
  });
}
